(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jd-footer-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const query = window.matchMedia('(min-width: 750px)');
    const columns = document.querySelectorAll('.jd-footer-col');
    if (!columns.length) return;

    // Static (open) on desktop, collapsible accordion on mobile.
    function sync() {
      columns.forEach((details) => {
        details.open = query.matches;
      });
    }

    sync();
    query.addEventListener('change', sync);
  })();

  /* Flags the document as soon as the footer navigation enters the viewport, so the fixed mobile
     bars (PDP add-to-cart, cart page checkout) can step aside instead of covering the footer links.
     Raised here rather than in each bar: the footer is the single thing they all react to, and it is
     rendered on every template. */
  (function () {
    const footer = document.querySelector('.jd-footer-nav');
    if (!footer) return;

    new IntersectionObserver(
      ([entry]) => {
        document.documentElement.toggleAttribute('data-jd-footer-visible', entry.isIntersecting);
      },
      { threshold: 0 }
    ).observe(footer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd-footer-reassurance"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      const scroller = root.querySelector('.jd-reassurance__list');
      const dots = root.querySelectorAll('.jd-reassurance__dot');
      if (!scroller || !dots.length) return;

      const items = scroller.children;

      function syncDots() {
        if (!items.length) return;
        const gap = parseFloat(getComputedStyle(scroller).columnGap) || 0;
        const step = items[0].getBoundingClientRect().width + gap;
        const index = Math.min(Math.round(scroller.scrollLeft / step), dots.length - 1);
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }

      scroller.addEventListener('scroll', () => requestAnimationFrame(syncDots), { passive: true });

      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          items[i] && items[i].scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'smooth' });
        });
      });
    }

    document.querySelectorAll('.jd-reassurance').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd-header"]) return;
  try {
    
  // Runtime sync of the header vars (the theme.liquid inline calc only runs once). Publishes:
  // --header-group-height + --jd-vh (JS-measured viewport; CSS 100dvh can sit a few px short on
  // mobile), and --jd-header-h, the <html> mirror used by the slider's scroll-padding (the
  // scroll container can't inherit a <body> var). Both from one measurement, so slide height and
  // snap offset stay identical → no mid-section rest. Kept in sync on resize / orientation.
  (function () {
    if (document.querySelector('header-component')) return; // native path owns these vars
    const group = document.getElementById('header-group');
    if (!group) return;

    const update = function () {
      let height = 0;
      for (const child of group.children) {
        // getBoundingClientRect keeps sub-pixel precision; offsetHeight rounds per child,
        // and the accumulated rounding leaves a hairline gap under a 100dvh section.
        if (child instanceof HTMLElement) height += child.getBoundingClientRect().height;
      }
      document.body.style.setProperty('--header-group-height', height + 'px');
      document.documentElement.style.setProperty('--jd-header-h', height + 'px');
      document.body.style.setProperty('--jd-vh', window.innerHeight + 'px');
    };

    update();

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(update);
      for (const child of group.children) {
        if (child instanceof HTMLElement) observer.observe(child);
      }
    }
    // Viewport-only changes (mobile toolbar show/hide, rotation) don't resize the header
    // children, so track them explicitly to keep --jd-vh in sync.
    window.addEventListener('resize', update);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', update);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd-media-with-text-overlay"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-jd-mwto-scroll]');
    if (!trigger) return;

    const current = trigger.closest('.shopify-section') || trigger.closest('.jd-mwto');
    const target = (current && current.nextElementSibling) || current;
    if (!target) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd-pdp-secondary-menu"] && !Shopify.designMode) return;
  try {
    
  // Which edge fade to show: hidden at the end it has reached, visible where content remains.
  // A row that doesn't overflow gets both hidden.
  (function () {
    function update(bar) {
      var row = bar.querySelector('[data-jd-pdp-secondary-menu-row]');
      if (!row) return;
      var overflows = row.scrollWidth > row.clientWidth + 1;
      var max = row.scrollWidth - row.clientWidth - 1;
      bar.classList.toggle('is-at-start', !overflows || row.scrollLeft <= 0);
      bar.classList.toggle('is-at-end', !overflows || row.scrollLeft >= max);
    }

    function updateAll() {
      document.querySelectorAll('[data-jd-pdp-secondary-menu]').forEach(update);
    }

    // Capture phase: scroll doesn't bubble.
    document.addEventListener(
      'scroll',
      function (event) {
        var row = event.target.closest && event.target.closest('[data-jd-pdp-secondary-menu-row]');
        if (row) update(row.parentElement);
      },
      true
    );

    window.addEventListener('resize', updateAll);
    document.addEventListener('DOMContentLoaded', updateAll);
    updateAll();

    // The active link can start off-screen in the scroller — bring it into view, horizontally and
    // on that element only, so the page itself never moves (scrollIntoView would scroll every
    // scrollable ancestor, the document included).
    function revealCurrent() {
      document.querySelectorAll('[data-jd-pdp-secondary-menu-row]').forEach(function (row) {
        var current = row.querySelector('.is-current');
        if (!current) return;
        var rowBox = row.getBoundingClientRect();
        var box = current.getBoundingClientRect();
        if (box.left >= rowBox.left && box.right <= rowBox.right) return;
        row.scrollLeft += box.left - rowBox.left;
        update(row.parentElement);
      });
    }

    document.addEventListener('DOMContentLoaded', revealCurrent);
    revealCurrent();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd-text-with-icon"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      const scroller = root.querySelector('.jd-text-icon__list');
      const dots = root.querySelectorAll('.jd-text-icon__dot');
      if (!scroller || !dots.length) return;

      const items = scroller.children;

      function syncDots() {
        if (!items.length) return;
        const gap = parseFloat(getComputedStyle(scroller).columnGap) || 0;
        const step = items[0].getBoundingClientRect().width + gap;
        const index = Math.min(Math.round(scroller.scrollLeft / step), dots.length - 1);
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }

      scroller.addEventListener('scroll', () => requestAnimationFrame(syncDots), { passive: true });

      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          items[i] && items[i].scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'smooth' });
        });
      });
    }

    document.querySelectorAll('.jd-text-icon').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd-video-player"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      const video = root.querySelector('.jd-video__media');
      const toggle = root.querySelector('.jd-video__toggle');
      const mute = root.querySelector('.jd-video__mute');
      const time = root.querySelector('.jd-video__time');
      if (!video || !toggle || !mute) return;

      function fmt(t) {
        t = Math.max(0, Math.floor(t || 0));
        const m = Math.floor(t / 60);
        const s = t % 60;
        return String(m).padStart(2, '0') + ' : ' + String(s).padStart(2, '0');
      }

      // Respect reduced-motion: no autoplay, hold on the poster.
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.removeAttribute('autoplay');
        video.pause();
      }

      function syncPlay() {
        const playing = !video.paused;
        root.classList.toggle('is-playing', playing);
        toggle.setAttribute('aria-label', playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay);
      }

      function syncMute() {
        root.classList.toggle('is-muted', video.muted);
        mute.setAttribute('aria-label', video.muted ? mute.dataset.labelUnmute : mute.dataset.labelMute);
      }

      toggle.addEventListener('click', function () {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });

      mute.addEventListener('click', function () {
        video.muted = !video.muted;
      });

      video.addEventListener('play', syncPlay);
      video.addEventListener('pause', syncPlay);
      video.addEventListener('volumechange', syncMute);
      video.addEventListener('timeupdate', function () {
        if (time) time.textContent = fmt(video.currentTime);
      });

      syncPlay();
      syncMute();
    }

    document.querySelectorAll('.jd-video__player').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
